import { EmptyState, PageHeader, Skeleton } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { EditUserForm } from '@/features/users/EditUserForm';
import { useUser } from '@/features/users/hooks';
import { useNavigate, useParams } from '@solidjs/router';
import { Show } from 'solid-js';

export default function AdminUserEdit() {
  const params = useParams<{ userId: string }>();
  const navigate = useNavigate();
  const { session } = useAuth();
  const query = useUser(() => params.userId);

  // Listing gates the page (parity with the old table Edit button); the API
  // enforces the real write permissions on save.
  const canList = () => session()?.permissions.has('users:list') ?? false;
  const done = () => navigate('/admin/users');

  return (
    <section>
      <PageHeader title={`Edit ${query.data?.data.email ?? 'user'}`} />
      <div class="mx-auto max-w-6xl p-6">
        <Show
          when={canList()}
          fallback={
            <EmptyState
              variant="error"
              title="No permission"
              body="You don't have permission to view users."
            />
          }
        >
          <Show when={!query.isPending} fallback={<Skeleton class="h-60" />}>
            <Show
              when={query.data?.data}
              fallback={<EmptyState variant="error" title="User not found" />}
            >
              {(user) => (
                <div class="rounded-xl border border-neutral-100 bg-surface p-6 shadow-sm dark:border-neutral-800 dark:bg-surface-dark">
                  <EditUserForm user={user()} onDone={done} onCancel={done} />
                </div>
              )}
            </Show>
          </Show>
        </Show>
      </div>
    </section>
  );
}
